import React, { useContext } from 'react';
import AppContext from '../../context/AuthProvider';
import { RouterPrivate, RouterPublic } from './Router';

const Home = () => {
  const { datalogin } = useContext(AppContext);

  const Routers = () => {
    return <>{datalogin ? <RouterPrivate /> : <RouterPublic />}</>;
  };
  return (
    <>
      <Routers />
    </>
  );
};

export default Home;
